import { render, staticRenderFns } from "./DashboardMenu.vue?vue&type=template&id=f21c579e&scoped=true&"
import script from "./DashboardMenu.vue?vue&type=script&lang=ts&"
export * from "./DashboardMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardMenu.vue?vue&type=style&index=0&id=f21c579e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21c579e",
  null
  
)

export default component.exports